/*
 * OUALO product page tabs
 * Replaces the Dawn accordion behaviour for the collapsible_tab blocks
 * (Description / Product Care / etc.) with a horizontal tab UI.
 */
(function () {
  function initTabGroup(group) {
    var triggers = group.querySelectorAll('.oualo-tabs__trigger');
    var panels = group.querySelectorAll('.oualo-tabs__panel');

    if (!triggers.length || !panels.length) return;

    triggers.forEach(function (trigger, index) {
      if (trigger.dataset.oualoTabsBound === 'true') return;
      trigger.dataset.oualoTabsBound = 'true';

      trigger.addEventListener('click', function () {
        triggers.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });

        trigger.classList.add('is-active');
        trigger.setAttribute('aria-selected', 'true');
        panels[index].hidden = false;
        panels[index].classList.add('is-active');
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.oualo-tabs').forEach(initTabGroup);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-init when a merchant edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // In case this script executes after DOMContentLoaded already fired.
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }
})();
